
import { Component, Emit, Vue } from 'vue-property-decorator';

import {
  Row,
  Heading,
  ButtonPrimary,
  RoundedIcon,
  BaseText,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';

import { Steps } from '../PortfolioSuggestedModal/PortfolioSuggestedModal.vue';
import { SuggestionType } from '@/modules/investments/types/suggestion';
import { SuggestionModule } from '@/modules/home/store/suggestions';
import format from 'date-fns/format';
import * as trackerInvestmentSuggesttedList from './track-investment-events';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { isWarrenManaged } from '@/modules/common/services/partner';
import { CustomerModule } from '@/modules/common/store/CustomerModule';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import * as trackerRedeemSuggesttedList from './track-redeem-events';

interface ISuggestionItem {
  id: string;
  name: string;
  status: string;
  createdAt?: string;
}

@Component({
  components: {
    LoaderIndicator,
    Row,
    Heading,
    ButtonPrimary,
    FadeTransition,
    RoundedIcon,
    BaseText
  }
})
export default class PortfolioSuggestedList extends Vue {
  readonly NebraskaColors = NebraskaColors;

  get isWarrenManaged() {
    return isWarrenManaged();
  }

  created() {
    SuggestionModule.resetData();
    this.trackingViewSuggestion();
  }

  private trackingViewSuggestion() {
    if (this.suggestionType === SuggestionType.Investment) {
      trackerInvestmentSuggesttedList.viewInvestmentSuggestionAmplitude();
    } else if (this.suggestionType === SuggestionType.Redeem) {
      trackerRedeemSuggesttedList.trackViewSuggestionmodal();
    }
  }

  @Emit('open-suggestion-details')
  private async openSuggestionDetails(suggestionId: string, name: string) {
    const customerId = CustomerModule.getCustomerId;
    this.trackingPortfolioSuggestedList(name);
    await SuggestionModule.getSuggestionDetails({ suggestionId, customerId });
    const nextStep = SuggestionModule.error ? Steps.Error : Steps.Detail;

    return {
      step: nextStep
    };
  }

  @Emit('close-modal')
  closeModal() {}

  private trackingPortfolioSuggestedList(name: string) {
    if (this.suggestionType === SuggestionType.Investment) {
      trackerInvestmentSuggesttedList.walletDetail(name);
      trackerInvestmentSuggesttedList.suggestedDetailsAmplitude(name);
    } else if (this.suggestionType === SuggestionType.Redeem) {
      trackerRedeemSuggesttedList.trackClickPortfolio();
    }
  }

  get hasSuggestions() {
    return this.formattedSuggestions && this.formattedSuggestions.length > 0;
  }

  get formattedSuggestions(): ISuggestionItem[] {
    switch (this.suggestionType) {
      case SuggestionType.Investment:
        return (
          this.investmentSuggestions?.data.map(item => ({
            name: item.portfolioName,
            status: 'pending',
            id: item.transactionId
          })) || []
        );
      case SuggestionType.Redeem:
        return (
          this.redeenSuggestions?.map(item => ({
            name: item.portfolio.name,
            id: item.portfolio.id,
            status: 'pending',
            createdAt: format(
              new Date(item.createdAt),
              `'Sugestão realizada em' dd/MM/yyyy 'às' HH:mm`
            )
          })) || []
        );
      default:
        return (
          this.walletSuggestions?.map(item => ({
            id: item.id!,
            name: item.name!,
            status: item.status!
          })) || []
        );
    }
  }

  get investmentSuggestions() {
    return SuggestionModule.suggestions?.investmentList;
  }

  get walletSuggestions() {
    return SuggestionModule.suggestions?.walletList;
  }

  get redeenSuggestions() {
    return SuggestionModule.suggestions?.redeemList;
  }

  get isLoading() {
    return SuggestionModule.isFetching;
  }

  get error() {
    return SuggestionModule.error;
  }

  get suggestionType() {
    return SuggestionModule.suggestionType;
  }

  get emptyListMessage() {
    const suggestionTypeLabel =
      this.suggestionType === SuggestionType.Redeem
        ? 'resgate'
        : 'investimento';
    return `Você avaliou todas as sugestões de ${suggestionTypeLabel}.`;
  }
}
